import React, { Component } from 'react';
import FormFieldInfoMessageProps from './FormFieldInfoMessage.props';
import FormFieldInfoMessageState from './FormFieldInfoMessage.state';

export default class FormFieldInfoMessage extends Component<FormFieldInfoMessageProps, FormFieldInfoMessageState> {
    constructor(props: FormFieldInfoMessageProps) {
        super(props);
        this.state = { 
            key: 'value'
        };
    }

    render(): React.ReactNode {
        return (
            <div className="form-field-info-message">
                <div className="form-field-info-message__icon icon_error-circle_alt"></div>
                <div className="form-field-info-message__text textblock" 
                    dangerouslySetInnerHTML={{__html: this.props.label}}></div>
            </div>
        );
    }
}
